module.exports = "<div style=\"display: none\"></div>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/nav/navbar.vue
// module id = 463
// module chunks = 0